import { useContext } from "react";
import { AdditionsTourContext } from "./AdditionsTourContext";

export const useAdditionsTour = () => {
    const ctx = useContext(AdditionsTourContext);
    if (!ctx) throw new Error("useAdditionsTour must be used inside AdditionsTourProvider");
    return ctx;
};
